module.exports = __webpack_public_path__ + "img/f87c1356-6998-4597-b5e1-8fd0dfa9efab.c2d6625c.webp";